import React from "react";

const Form : React.FC<IFormProps> = (props) => {
    return (
        <form {...props} style={{width: '100%'}} autoComplete='off'>
            {props.children}
        </form>
    );
}

interface IFormProps extends React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement> {
}

export default Form;